import React, { useEffect } from 'react';

import produce from 'immer';
import { Controller } from 'react-hook-form';

import { useQueryState } from 'hooks/useQueryState';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import classes from 'components/common/GlobalFilterComponent/GlobalFilterComponent.module.scss';
import { FilterLabels } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import { Range } from 'components/common/GlobalFilterComponent/components/RangeFilter/rangeFilter';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    setState?: React.Dispatch<React.SetStateAction<any>>;
    handleFilters?: () => void;
    className?: string;
}

export type Options = 'true' | 'false';

export const options: ISelectOption<Options>[] = [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
];

export const PartialCompletionCreditFilter = ({ methods, name, setState, handleFilters, className }: Props) => {
    const [queryStringValue] = useQueryState(name);
    const { getValueFromStore } = useGlobalFilterDataStore();
    const storeValue = getValueFromStore<Range>(name);

    const formValue = methods?.getValues(name);
    const isValue = formValue || queryStringValue || storeValue;

    useEffect(() => {
        if (setState) {
            if (!isValue) {
                setState((prev) => {
                    return produce(prev, (draft) => {
                        draft[name].isReady = true;
                        draft[name].isEmpty = true;
                        return draft;
                    });
                });
            }
            if (isValue) {
                methods?.setValue(name, isValue);
                setState((prev) => {
                    return produce(prev, (draft) => {
                        draft[name].isReady = true;
                        return draft;
                    });
                });
            }
        }
    }, [isValue, setState]);

    const handleChange = (option: ISelectOption<Options> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }
        return options.find((item) => item.value === isValue) || null;
    };
    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <span className={classes.title}>{FilterLabels.partialCompletionCredit}</span>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<Options>>
                            {...field}
                            options={options}
                            id={'global-filter-component-partial-completion-credit'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
